module.exports = __webpack_public_path__ + "a655e1af836dac3a99a1d222adf00fa0.MP3";